// Terminal node rendered only when CampaignState.status === 'done'.
// Labelled "Surrogate" — deliberately generic, no algorithm detail.

import { Handle, Position } from '@xyflow/react';
import { fallbackTheme } from './theme';
import { NODE_SIZES } from './provenanceLayout';

export interface SurrogateNodeData {
  pointsComplete: number;
  finalMaxSigma?: number;
}

export default function SurrogateNode({ data }: { data: SurrogateNodeData }) {
  const t = fallbackTheme;
  const { width, height } = NODE_SIZES.surrogate;
  return (
    <div
      style={{
        width,
        height,
        background: t.surfaceRaised,
        border: `1px solid ${t.accent}`,
        borderRadius: 10,
        padding: '10px 14px',
        color: t.text,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        gap: 4,
      }}
    >
      <div style={{ fontSize: 10, color: t.textMuted, textTransform: 'uppercase', letterSpacing: 0.5 }}>
        Result
      </div>
      <div style={{ fontSize: 14, fontWeight: 600 }}>Surrogate</div>
      <div style={{ fontSize: 11, color: t.textMuted }}>
        Fit over {data.pointsComplete} sample{data.pointsComplete === 1 ? '' : 's'}
        {typeof data.finalMaxSigma === 'number' && (
          <> · final max uncertainty {data.finalMaxSigma.toFixed(3)}</>
        )}
      </div>
      <Handle type="target" position={Position.Top} style={{ background: t.border }} />
    </div>
  );
}
